import { Injectable } from '@angular/core';
import { HttpService } from '../../../shared/services/http/http-client.service';
import { environment } from '../../../../environments/environment';

const API = environment.url_server;

@Injectable({
  providedIn: 'root'
})
export class ExtratoReusoAutomaticoService {

  constructor(
    private http: HttpService
  ) { }

  extratoReuso(data: any, successHandle: Function, errorHandle: Function) {

    return this.http.doGet('/automaticReuse/extrato/', data, successHandle, errorHandle);

  }
 
}
